import styled from '@emotion/styled';

import { COLOR_SURFACE_INSET, COLOR_TEXT_CODE, FONT_MONO, RADIUS_SM } from './utils/variables';

export const CodeText = styled.span`
  font-family: ${FONT_MONO};
  font-size: 12px;
  color: ${COLOR_TEXT_CODE};
  background: ${COLOR_SURFACE_INSET};
  padding: 3px 8px;
  border-radius: ${RADIUS_SM};
`;
